/**
 * @author harish.r <harish.r@314ecorp.com>
 * @description Component for custom checkbox field
 */

import { Checkbox } from 'antd';

export interface IProps {
	value: boolean;
	onChange: (value: boolean) => void;
	label: string;
	disabled?: boolean;
}

/**
 * Formily custom checkbox
 * @param {IProps} props props
 * @returns {React.FC} CustomCheckbox
 */
const CustomCheckbox: React.FC<IProps> = ({ value, onChange, label, disabled }) => {
	const handleChange = (e: AnyType) => {
		onChange(e.target.checked);
	};

	return (
		<Checkbox checked={value} onChange={handleChange} disabled={disabled}>
			{label}
		</Checkbox>
	);
};
export default CustomCheckbox;
